import { render, staticRenderFns } from "./Vouchers.vue?vue&type=template&id=3ad9e9b4&"
import script from "./Vouchers.vue?vue&type=script&lang=ts&"
export * from "./Vouchers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports